import UnifiedSearchableSelect from './UnifiedSearchableSelect';
import type { UnifiedSearchableSelectOption } from './UnifiedSearchableSelect';

export type SimpleSelectOption = UnifiedSearchableSelectOption;

type SimpleSelectProps = {
  options: SimpleSelectOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  id?: string;
  disabled?: boolean;
};

const SimpleSelect = ({
  options,
  value,
  onChange,
  placeholder = '',
  id,
  disabled = false,
}: SimpleSelectProps) => (
  <UnifiedSearchableSelect
    id={id ?? 'simple-select'}
    options={options}
    multiple={false}
    searchable={false}
    disabled={disabled}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
  />
);

export default SimpleSelect;
